'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { TableHeaderCellContext } from './context/table-header-cell.context';
import type { TableBodyPropsInterface } from './types/table-body.types';

/**
 * A native [`<tbody>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/tbody) element.
 *
 * @since 8.0.0
 */
export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyPropsInterface>(
  (props: TableBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    return (
      <TableHeaderCellContext.Provider value={{ parent: 'body' }}>
        <tbody
          ref={forwardedRef}
          data-c11n-version={__C11N_VERSION__}
          data-c11n-component="Table.Body"
          className={cx('c11n', css(cssProp), className)}
          {...rest}
        >
          {children}
        </tbody>
      </TableHeaderCellContext.Provider>
    );
  },
);

TableBody.displayName = 'Table.Body';
